var _circle, _path, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    stroke: "#2ABE9A",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94062 7.87796C4.18695 8.09129 4.51154 8.24544 4.86133 8.34641C5.21506 8.44852 5.60708 8.5 6 8.5C6.39292 8.5 6.78494 8.44852 7.13868 8.34641C7.48846 8.24544 7.81305 8.09129 8.05938 7.87796",
    stroke: "#2ABE9A",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 5,
    r: 0.5,
    fill: "#2ABE9A",
    stroke: "#2ABE9A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 5,
    r: 0.5,
    fill: "#2ABE9A",
    stroke: "#2ABE9A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.cdd0ec4226b560e6ee14c17b102ae156.svg";
export { ForwardRef as ReactComponent };